import client from "@/lib/ApiClient";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    instances: null,
    plans: null,
    tenants: null,
    subscriptions: null,
    ledger: null,
    invoices: null,
    quotas: null,
    quotaAggregate: null,
    ledgerTimeSeries: null,
  },

  getters: {
    instances: (state) => state.instances,
    plans: (state) => state.plans,
    tenants: (state) => state.tenants,
    subscriptions: (state) => state.subscriptions,
    ledger: (state) => state.ledger,
    invoices: (state) => state.invoices,
    quotas: (state) => state.quotas,
    quotaAggregate: (state) => state.quotaAggregate,
    ledgerTimeSeries: (state) => state.ledgerTimeSeries,
  },

  mutations: {
    SET_INSTANCES(state, payload) {
      state.instances = payload;
    },
    SET_PLANS(state, payload) {
      state.plans = payload;
    },
    SET_TENANTS(state, payload) {
      state.tenants = payload;
    },
    SET_SUBSCRIPTIONS(state, payload) {
      state.subscriptions = payload;
    },
    SET_LEDGER(state, payload) {
      state.ledger = payload;
    },
    SET_INVOICES(state, payload) {
      state.invoices = payload;
    },
    SET_QUOTAS(state, payload) {
      state.quotas = payload;
    },
    SET_QUOTA_AGGREGATE(state, payload) {
      state.quotaAggregate = payload;
    },
    SET_LEDGER_TIME_SERIES(state, payload) {
      state.ledgerTimeSeries = payload;
    },
  },

  actions: {
    setInstances({ commit }, payload) {
      commit("SET_INSTANCES", payload);
    },
    setPlans({ commit }, payload) {
      commit("SET_PLANS", payload);
    },
    setTenants({ commit }, payload) {
      commit("SET_TENANTS", payload);
    },
    setSubscriptions({ commit }, payload) {
      commit("SET_SUBSCRIPTIONS", payload);
    },
    setLedger({ commit }, payload) {
      commit("SET_LEDGER", payload);
    },
    setInvoices({ commit }, payload) {
      commit("SET_INVOICES", payload);
    },
    setQuotas({ commit }, payload) {
      commit("SET_QUOTAS", payload);
    },
    setQuotaAggregate({ commit }, payload) {
      commit("SET_QUOTA_AGGREGATE", payload);
    },
    setLedgerTimeSeries({ commit }, payload) {
      commit("SET_LEDGER_TIME_SERIES", payload);
    },

    async loadData({ commit }) {
      const api = client.gateway.management;
      const tasks = [
        { fn: api.fetchInstances, key: "SET_INSTANCES" },
        { fn: api.fetchPlans, key: "SET_PLANS" },
        { fn: api.fetchTenants, key: "SET_TENANTS" },
        { fn: api.fetchSubscriptions, key: "SET_SUBSCRIPTIONS" },
        { fn: api.fetchLedger, key: "SET_LEDGER" },
        { fn: api.fetchInvoices, key: "SET_INVOICES" },
        { fn: api.fetchQuotas, key: "SET_QUOTAS" },
        {
          fn: api.fetchQuotaAggregate,
          key: "SET_QUOTA_AGGREGATE",
        },
        {
          fn: api.fetchLedgerTimeSeries,
          key: "SET_LEDGER_TIME_SERIES",
        },
      ];

      const results = await Promise.allSettled(tasks.map((t) => t.fn()));

      results.forEach((r, i) => {
        const { key } = tasks[i];

        if (r.status === "fulfilled") {
          commit(key, r.value);
        } else {
          console.error(`Failed to load ${key}:`, r.reason);
        }
      });
    },
  },
});
